 <h1> TEST </h1>
 <div style="padding: 50px;">
    <app-date-picker [(ngModel)]="datevalue" #date="ngModel"></app-date-picker>
 </div>
   
   
    